import styled from 'styled-components';

const ErrorMessage = styled.div`
  margin: 16px 0;
  color: red;
`;

export default ErrorMessage;
